import { LocaleData } from '../interfaces/picker-locale-data'

export const localeData: LocaleData = {
  direction: 'ltr',
  format: 'dd/mm/yyyy',
  daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
  monthNames: ['Jan', 'Fév', 'Mars', 'Avr', 'Mai', 'Juin', 'Juill', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'],
  firstDay: 1,
}
